import { t } from 'ember-intl';
import BvInline from 'volta/components/bv-inline';
import BvTag from 'volta/components/bv-tag';
import BvText from 'volta/components/bv-text';

import type { TOC } from '@ember/component/template-only';

interface CreateOptionSignature {
  Args: {
    term?: string;
  };
  Element: HTMLDivElement;
}

const CreateOption: TOC<CreateOptionSignature> = <template>
  <BvInline @gap='2' @blockAlign='center'>
    <BvText @text={{t 'add'}} />
    <BvTag @size='sm' @color='primary' @text={{@term}} />
  </BvInline>
</template>;

export default CreateOption;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvSelectCreate::CreateOption': typeof CreateOption;
    'bv-select-create/create-option': typeof CreateOption;
  }
}
